import type { ViewValues } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';
import type { PageMode } from './pubSubConstants.ts';

export const QuickReload: LoadableType<{
	contentId: string;
	contentType?: string | null;
	lastPollTime: number;
	timerOverride?: any;
	pageMode: PageMode;
	pageCommentsSectionInView?: boolean;
	isFabricPage?: boolean;
	showCommentsPanel?: (opts?: { openWithView?: ViewValues }) => void;
}> = LoadableBackground({
	loader: async () => {
		const { QuickReload } = await import(
			/* webpackChunkName: "loadable-QuickReload" */ '../src/QuickReload.tsx'
		);
		return QuickReload;
	},
});
